import { Component, OnInit } from '@angular/core';
import { UserActionBodyComponent } from '@core_n/user-action/user-action.component';
import * as projEnums from '../common/projEnums';
import { TrackObject } from '../asp/TrackObject';

@Component({
  selector: 'app-set-double-flag-action',
  templateUrl: './set-double-flag-action.component.html',
  styleUrls: ['./set-double-flag-action.component.scss']
})
export class SetDoubleFlagActionComponent extends UserActionBodyComponent implements OnInit {

  source: projEnums.FieldSource = projEnums.FieldSource.Menatev;

  public sources = [];

  constructor() {
    super();

    let sources = projEnums.FieldSourceKeys.map(Number);
    for (let src of sources)
      this.sources.push({ title: projEnums.fieldSourceTitle(src), id: src });
  }

  ngOnInit() {
    
  }

  getData(): any {
    return { source: this.source };
  }
}
